export default function validateExpiryDate(expiryDate: string): boolean {
  return expiryDate && (Date.parse(expiryDate)) < (new Date().valueOf());
  // if (expiryDate && (Date.parse(expiryDate)) < (new Date().valueOf())) {
  //   return (<Trans>Your document has expired. Please use another one.</Trans>);
  // }
  // return '';
}
